// Redirect bridge for MSAL v5 COOP support.
// Excluded from MsalProvider in main.tsx so MSAL does not consume the auth response.
import { useEffect } from 'react'
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge'

import { AuthLoading } from '@/features/auth/components/auth-loading'

export const LoginRedirect = () => {
  useEffect(() => {
    void broadcastResponseToMainFrame().catch((error: unknown) => {
      console.error('Error broadcasting response to main frame:', error)
    })
  }, [])

  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <AuthLoading />
    </main>
  )
}
